export async function loadMasterData(filename, localData) {
  const remoteUrl = `https://indodeftech.com/data/getMaster.php?file=${filename}`;

  try {
    const response = await fetch(remoteUrl, { cache: "no-store" });
    const result = await response.json();

    if (!response.ok || !result.success || !Array.isArray(result.items)) {
      throw new Error(result.error || "Failed to load data");
    }

    console.log(`✅ Loaded ${filename} via PHP`);
    return result.items;
  } catch (err) {
    console.warn(`⚠️ Using local fallback for ${filename}:`, err.message);
    return localData;
  }
}
